var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notice-wrap"},[_c('img',{staticClass:"notice-image",attrs:{"src":_vm.url,"alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }